import { Result } from 'antd'

export default function Error(): JSX.Element {
  return <Result status="404" title="없는 페이지 입니다." />
}
